import type { AnalyticsData, AnalyticsStrategy, Primitive } from './types';

export class AnalyticsManager<T = Primitive> {
  private providers: AnalyticsStrategy<T>[] = [];

  addProvider(...providers: AnalyticsStrategy<T>[]) {
    const uniqueProviders = new Set([...this.providers, ...providers]);
    this.providers = Array.from(uniqueProviders);
    return this;
  }

  removeProvider(providerToRemove: AnalyticsStrategy<T>) {
    this.providers = this.providers.filter((provider) => (
      provider !== providerToRemove
    ));
    return this;
  }

  sendEvent(eventName: string, data?: AnalyticsData<T>) {
    const promises = this.providers.map((provider) => provider.sendEvent(eventName, data));

    return Promise.all(promises);
  }
}
